import {
    type GetThreetTokenForGuestsResponseType,
    type GetThreetTokenForGuestsRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetThreetTokenForGuests = async (params: GetThreetTokenForGuestsRequestType): Promise<GetThreetTokenForGuestsResponseType> => {
    return await axios(`${SERVER_ADDRESS}/event/getThreetTokenForGuests`, {
        method: "GET",
        headers: getHeaders(),
        params: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default GetThreetTokenForGuests;
